module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StartPage/maro_instagram_connect-f15d0a2d10f384d653310fa7fc3fa0cd.svg";